import { dtoFormFields } from "../constants/data";

export const getFillDtoVenues = (params, idAddress) => {
  const cloneDtoFormFields = { ...dtoFormFields };
  const addressDto = { ...dtoFormFields.addressDto };

  cloneDtoFormFields.aquaticCenter = params.aquaticCenter;
  cloneDtoFormFields.building = params.building;
  cloneDtoFormFields.poolName = params.poolName;
  cloneDtoFormFields.schoolInstitution = params.schoolInstitution;

  for (let key in addressDto) {
    addressDto[key] = params[key];
  }

  if (idAddress) addressDto.id = idAddress;

  return { ...cloneDtoFormFields, addressDto };
};
export const getFillDtoAd = (params, defaultDto) => {
  return {
    ...defaultDto,
    id: params.id ?? defaultDto.id ?? null,
    teamId: params.teamId ?? defaultDto.teamId ?? null,
    adType: params.adType ?? defaultDto.adType ?? null,

    name: params.name?.trim() ?? null,
    clickUrl: params.clickUrl?.trim() ?? null,

    imageUrl: params.imageUrl?.trim() ?? null,
    imageObjectKey: params.imageObjectKey?.trim() ?? null,

    status: params.status ?? defaultDto.status ?? "ACTIVE",

    ages: params.ages?.trim() ?? null,
    levels: params.levels?.trim() ?? null,
    shortDescription: params.shortDescription?.trim() ?? null,
    ctaText: params.ctaText?.trim() ?? null,

    city: params.city?.trim() ?? null,
    region: params.region?.trim() ?? null,
    country: params.country?.trim() ?? null,

    maxUniqueImpressions:
      params.maxUniqueImpressions === "" || params.maxUniqueImpressions == null
        ? null
        : Number(params.maxUniqueImpressions),

    maxUniqueClicks:
      params.maxUniqueClicks === "" || params.maxUniqueClicks == null
        ? null
        : Number(params.maxUniqueClicks),

    priority:
      params.priority === "" || params.priority == null
        ? 0
        : Number(params.priority),

    targetRoles: Array.isArray(params.targetRoles)
      ? params.targetRoles
          .map((r) => (typeof r === "string" ? r : r?.id))
          .filter(Boolean)
      : defaultDto.targetRoles ?? [],

    governingBodies: Array.isArray(params.governingBodies)
      ? params.governingBodies
      : [],

    startDate: params.startDate ?? null,
    endDate: params.endDate ?? null,
  };
};
export const getFillDtoTeam = (
  params,
  dtoFormTeamFields,
  contactInformationID,
) => {
  const base = dtoFormTeamFields || {};

  // clone base so we never mutate callers
  const cloneDtoTeam = {
    ...base,
    contactInformation: { ...(base.contactInformation || {}) },
    governingBodies: Array.isArray(base.governingBodies)
      ? [...base.governingBodies]
      : [],
    venues: Array.isArray(base.venues) ? [...base.venues] : [],
    logoChanged: !!params?.logoChanged,
  };

  // 1) Handle nested contactInformation explicitly
  const incomingCI = params?.contactInformation || {};

// conference should be null and not ""
  const emptyToNull = (v) =>
    typeof v === "string" && v.trim() === "" ? null : v;

  for (let n in cloneDtoTeam.contactInformation) {
    // Prefer nested value, then flat fallback (for older callers), otherwise keep existing
    const next = Object.prototype.hasOwnProperty.call(incomingCI, n)
      ? incomingCI[n]
      : Object.prototype.hasOwnProperty.call(params || {}, n)
      ? params[n]
      : cloneDtoTeam.contactInformation[n];

    // Only overwrite when the caller actually provided something (including empty string)
    if (next !== undefined) {
      cloneDtoTeam.contactInformation[n] = next;
    }
  }

  // Preserve id if provided
  if (contactInformationID) {
    cloneDtoTeam.contactInformation.id = contactInformationID;
  } else if (incomingCI?.id != null) {
    cloneDtoTeam.contactInformation.id = incomingCI.id;
  }

  // 2) Handle cloudAlias -> logoUrl mapping
  if (Object.prototype.hasOwnProperty.call(params || {}, "cloudAlias")) {
    cloneDtoTeam.logoUrl = params.cloudAlias || null;
  }

  // 3) For all other top-level keys, only overwrite if caller provided it
  for (let key in cloneDtoTeam) {
    if (key === "contactInformation") continue;
    if (key === "logoUrl") continue; // handled above

    if (Object.prototype.hasOwnProperty.call(params || {}, key)) {
      const raw = params[key];

      // conference is an object on the backend (ConferenceDTO) so "" must become null
      if (key === "conference") {
        cloneDtoTeam[key] = emptyToNull(raw);
        continue;
      }

      // Default behavior: keep existing only if undefined, otherwise allow null/false/0 through
      cloneDtoTeam[key] = raw === undefined ? cloneDtoTeam[key] : raw;
    }
  }

  if (Object.prototype.hasOwnProperty.call(params || {}, "teamType")) {
    cloneDtoTeam.teamType = params.teamType || null;
  }

  return cloneDtoTeam;
};
